import { DataAccess, ProductDataAccess, ProjectDataAccess } from '@/security/types/DataAccess';

export function toProductDataAccess(projectDataAccess?: Nullable<DataAccess>): ProductDataAccess {
  return projectDataAccess === ProjectDataAccess.ShowAllData
    ? ProductDataAccess.ShowAllData
    : ProductDataAccess.HideAllDesignData;
}
